var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.type ? _vm.$t("停用部门") : _vm.$t("启用部门"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 620
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "reason",
      label: _vm.$t("停用原因")
    }
  }, [_c("a-textarea", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("停用原因"),
      "auto-size": {
        minRows: 2,
        maxRows: 6
      }
    },
    model: {
      value: _vm.dataFrom.reason,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "reason", $$v);
      },
      expression: "dataFrom.reason"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };